import React from 'react'

import { Chip, Icon, ThemeProvider } from '@material-ui/core'

import { selectChip } from '../../services/theme'

export const DangerChip = (props) => {
	const { onDelete, value } = props

	return (
		<ThemeProvider theme={selectChip}>
			{Boolean(onDelete) ? (
				<Chip
					value={value}
                   
					deleteIcon={
						<div
							onMouseDown={(event) => {
								if (!props.disabled && event.button === 0) {
									event.stopPropagation()
									onDelete(value)
								}
							}}>
							<Icon className="MuiChip-dangerIcon fas fa-times"  style={{ color: '#D02C2C' }}/>
						</div>
					}
					{...props}
				/>
			) : (
				<Chip {...props} />
			)}
		</ThemeProvider>
	)
}
